export enum NewPackFormKeys {
    Name = 'name',
    Description = 'description',
    LabelName = 'labelName',
    Genre = 'genre',
    Subgenre = 'subgenre',
    Exclusivity = 'exclusivity',
    Lexicon = 'useSfxLexicon',
    ArtworkUpload = 'artworkUpload',
    CsvUpload = 'csvUpload',
    DemoUpload = 'demoUpload',
    ZipUpload = 'zipUpload',
    CsvUploadId = 'csvUploadId',
    DemoUploadId = 'demoUploadId',
    ArtworkUploadId = 'artworkUploadId',
    ZipUploadId = 'zipUploadId',
}

export type NewPackFormHiddenFieldKeys =
    | NewPackFormKeys.CsvUploadId
    | NewPackFormKeys.DemoUploadId
    | NewPackFormKeys.ArtworkUploadId
    | NewPackFormKeys.ZipUploadId;

export type NewPackFormVisibleFieldKeys = Exclude<
    NewPackFormKeys,
    NewPackFormHiddenFieldKeys
>;

export interface NewPackFormFields {
    [NewPackFormKeys.Name]: string;
    [NewPackFormKeys.Description]: string;
    [NewPackFormKeys.LabelName]: string;
    [NewPackFormKeys.Genre]: string;
    [NewPackFormKeys.Subgenre]: string;
    [NewPackFormKeys.Exclusivity]: string;
    [NewPackFormKeys.Lexicon]: string;
    [NewPackFormKeys.CsvUpload]: File | undefined;
    [NewPackFormKeys.DemoUpload]: File | undefined;
    [NewPackFormKeys.ArtworkUpload]: File | undefined;
    [NewPackFormKeys.ZipUpload]: File | undefined;
    [NewPackFormKeys.CsvUploadId]: string;
    [NewPackFormKeys.DemoUploadId]: string;
    [NewPackFormKeys.ArtworkUploadId]: string;
    [NewPackFormKeys.ZipUploadId]: string;
}
